<app-header
    [clicked]="clickedOutside"
    [langSel]="languageSelected"
    (changeMegaMenuCondition)="changeMenuCondition($event)"
    (selectedLanguage)="switchLanguageHandler($event)"
></app-header>
<div
    *ngIf="!submittedSuccessfully"
    (click)="closeMegaMenuCondition()"
    class="tw-hidden md:tw-hidden lg:tw-block"
>
    <div
        class="tw-flex tw-justify-left tw-items-center lg:tw-items-start tw-bg-[#FFFCF9] tw-py-20 tw-px-[5vw]"
    >
        <div
            class="tw-flex tw-flex-col tw-w-full tw-px-[10vw] lg:tw-px-[5vw]"
        >
            <div class="tw-text-[18px] tw-text-[#8D8D8D] tw-font-medium">
                {{ "CHATBOT_SURVEY_PAGE.VALUE" | translate }}
            </div>
            <div class="tw-flex tw-justify-between">
                <div
                    class="tw-text-[32px] tw-font-bold tw-mt-3 tw-text-[#000000]"
                >
                    {{ "CHATBOT_SURVEY_PAGE.TITLE" | translate }}
                </div>
                <div
                    class="tw-flex tw-items-center tw-text-[16px] tw-text-[#8D8D8D] tw-font-medium"
                >
                    {{ "CHATBOT_SURVEY_PAGE.RATING_DESC" | translate }}
                </div>
            </div>
            <hr class="tw-mt-[20px]" />
            <div class="tw-mt-[20px] tw-flex tw-flex-col tw-justify-center">
                <div
                    [ngClass]="rating > 0 ? 'rating-section-after' : 'rating-section-before'"
                > 
                    <button
                        mat-icon-button
                        *ngFor="let ratingId of starRatingArr;index as i"
                        (click)="onClickRating(i+1)"
                    >
                        <mat-icon>{{showIcon(i)}}</mat-icon>
                    </button>
                </div>
                <div
                    class="tw-flex tw-justify-center tw-text-[18px] tw-font-medium tw-text-[#4B6EEC] tw-pt-[70px]"
                >
                    {{ "CHATBOT_SURVEY_PAGE.RATE_OUR_CHATBOT" | translate }}
                </div>
            </div>
            <div
                class="tw-mt-[60px] tw-flex tw-justify-left tw-text-[18px] tw-font-bold tw-text-[#000000]"
            >
                {{ "CHATBOT_SURVEY_PAGE.RATE_ASPECT" | translate }}
            </div>
            <div class="tw-mt-[40px] tw-flex tw-flex-row">
                <div class="center tw-w-[40%] tw-max-w-full tw-text-[18px] tw-font-semibold">
                    {{ "CHATBOT_SURVEY_PAGE.Q_OVERALL_EXPERIENCE" | translate }}
                </div>
                <div class="tw-flex tw-justify-between">
                    <button
                        mat-mini-fab
                        color=""
                        (click)="overal_exp = i+1"
                        [ngClass]="overal_exp !== i+1 ? 'matBtn' : 'matBtnAfter'"
                        *ngFor="let Id of circleRatingArr; index as i"
                    >
                        {{i+1}}
                    </button>
                </div>
            </div>
            <div class="tw-mt-[40px] tw-flex tw-flex-row">
                <div class="center tw-w-[40%] tw-max-w-full tw-text-[18px] tw-font-semibold">
                    {{ "CHATBOT_SURVEY_PAGE.Q_EASE_OF_USE" | translate }}
                </div>
                <div class="tw-flex tw-justify-right">
                    <button
                        mat-mini-fab
                        color=""
                        (click)="ease_of_use = i+1"
                        [ngClass]="ease_of_use !== i+1 ? 'matBtn' : 'matBtnAfter'"
                        *ngFor="let Id of circleRatingArr; index as i"
                    >
                        {{i+1}}
                    </button>
                </div>
            </div>
            <div class="tw-mt-[40px] tw-flex tw-flex-row">
                <div class="center tw-w-[40%] tw-max-w-full tw-text-[18px] tw-font-semibold">
                    {{ "CHATBOT_SURVEY_PAGE.Q_INFORMATIVE" | translate }}
                </div>
                <div class="tw-flex tw-justify-right">
                    <button
                        mat-mini-fab
                        color=""
                        (click)="informative = i+1"
                        [ngClass]="informative !== i+1 ? 'matBtn' : 'matBtnAfter'"
                        *ngFor="let Id of circleRatingArr; index as i"
                    >
                        {{i+1}}
                    </button>
                </div>
            </div>
            <div
                class="tw-mt-[60px] tw-flex tw-justify-left tw-text-[18px] tw-font-bold tw-text-[#000000]"
            >
                {{ "CHATBOT_SURVEY_PAGE.YOUR_FEEDBACK" | translate }}
            </div>
            <form [formGroup]="feedbackForm">
                <textarea
                    class="tw-mt-[20px] tw-w-[100%] tw-h-36 tw-bg-gray-200 tw-font-[500] tw-overflow-auto tw-rounded-3xl tw-pt-3.5 tw-pb-3.5 tw-px-6"
                    placeholder="{{
                        'CHATBOT_SURVEY_PAGE.PH_YOUR_FEEDBACK' | translate
                    }}"
                    formControlName="feedback"
                >
                </textarea>
            </form>

            <div (click)="closeMegaMenuCondition()">
                <div
                    class="tw-mt-[40px] tw-hidden lg:tw-flex tw-flex-wrap tw-gap-[10px] tw-items-center md:tw-bg-white md:tw-rounded-[80px] tw-py-[10px] tw-px-0 md:tw-px-[15px] lg:tw-px-[27px]"
                >
                    <div
                        class="tw-order-2 md:tw-order-1 tw-flex-[0_0_calc(50%_-_5px)] md:tw-flex-[0_0_calc(100%_-_200px)]"
                    >
                        <button
                            (click)="onCancel()"
                            class="tw-text-caption-gray md:tw-max-w-full tw-w-full tw-text-justify tw-pl-[20px]"
                        >
                            {{ "CANCEL" | translate }}
                        </button>
                    </div>
                    <div
                        class="tw-order-1 md:tw-order-3 tw-flex-[0_0_100%] md:tw-flex-[0_0_180px] tw-mb-[18px] md:tw-mb-0"
                    >
                        <button
                            class="tw-text-[18px] tw-leading-[20px] md:tw-max-w-[175px] tw-w-full tw-text-center tw-font-[600] tw-rounded-[32px] tw-text-white tw-py-[22px] tw-px-[15px]"
                            type="submit"
                            [ngClass]="
                                (
                                    this.rating == 0 ||
                                    this.overal_exp == 0 ||
                                    this.ease_of_use == 0 ||
                                    this.informative == 0
                                )
                                ? 'tw-bg-slate-300'
                                : 'tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300'
                            "
                            (click)="onSubmit()"
                        >
                            {{ "COMMON.SUBMIT" | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div
    *ngIf="!submittedSuccessfully"
    (click)="closeMegaMenuCondition()"
    class="tw-block sm:tw-block lg:tw-hidden"
>
    <div
        class="tw-flex tw-justify-center tw-items-center sm:tw-items-center lg:tw-items-start tw-bg-[#FFFCF9] tw-py-20 tw-px-[5vw]"
    >
        <div
            class="tw-w-full tw-px-[10vw] lg:tw-px-[5vw]"
        >
            <div class="tw-text-center tw-text-[18px] tw-text-[#8D8D8D] tw-font-medium">
                {{ "CHATBOT_SURVEY_PAGE.VALUE" | translate }}
            </div>
            <div class="tw-text-center">
                <div
                    class="tw-text-[24px] tw-font-bold tw-mt-2 tw-text-[#000000]"
                >
                    {{ "CHATBOT_SURVEY_PAGE.TITLE" | translate }}
                </div>
                <div
                    class="tw-mt-[25px] tw-items-center tw-text-[16px] tw-text-[#8D8D8D] tw-font-medium"
                >
                    {{ "CHATBOT_SURVEY_PAGE.RATING_DESC" | translate }}
                </div>
            </div>
            <hr class="tw-mt-[25px]" />
            <div class="tw-mt-[20px] tw-flex tw-flex-col tw-justify-center">
                <div
                    [ngClass]="rating > 0 ? 'rating-section-after' : 'rating-section-before'"
                > 
                    <button
                        mat-icon-button
                        *ngFor="let ratingId of starRatingArr;index as i"
                        (click)="onClickRating(i+1)"
                    >
                        <mat-icon>{{showIcon(i)}}</mat-icon>
                    </button>
                </div>
                <div
                    class="tw-flex tw-justify-center tw-text-[18px] tw-font-medium tw-text-[#4B6EEC] tw-pt-[70px]"
                >
                    {{ "CHATBOT_SURVEY_PAGE.RATE_OUR_CHATBOT" | translate }}
                </div>
            </div>
            <div
                class="tw-mt-[60px] tw-text-center tw-justify-center tw-text-[16px] tw-font-bold tw-text-[#000000]"
            >
                {{ "CHATBOT_SURVEY_PAGE.RATE_ASPECT" | translate }}
            </div>
            <div class="tw-text-center tw-mt-[40px] tw-max-w-full tw-text-[16px]">
               {{ "CHATBOT_SURVEY_PAGE.Q_OVERALL_EXPERIENCE" | translate }}
            </div>
            <div class="tw-mt-[20px] tw-flex tw-justify-between">
                <button
                    mat-mini-fab
                    color=""
                    (click)="overal_exp = i+1"
                    [ngClass]="overal_exp !== i+1 ? 'matBtn' : 'matBtnAfter'"
                    *ngFor="let Id of circleRatingArr; index as i"
                >
                    {{i+1}}
                </button>
            </div>
            <div class="tw-text-center tw-mt-[40px] tw-max-w-full tw-text-[16px]">
                {{ "CHATBOT_SURVEY_PAGE.Q_EASE_OF_USE" | translate }}
            </div>
            <div class="tw-mt-[20px] tw-flex tw-justify-between">
                <button
                    mat-mini-fab
                    color=""
                    (click)="ease_of_use = i+1"
                    [ngClass]="ease_of_use !== i+1 ? 'matBtn' : 'matBtnAfter'"
                    *ngFor="let Id of circleRatingArr; index as i"
                >
                    {{i+1}}
                </button>
            </div>
            <div class="tw-text-center tw-mt-[40px] tw-max-w-full tw-text-[16px]">
                {{ "CHATBOT_SURVEY_PAGE.Q_INFORMATIVE" | translate }}
            </div>
            <div class="tw-mt-[20px] tw-flex tw-justify-between">
                <button
                    mat-mini-fab
                    color=""
                    (click)="informative = i+1"
                    [ngClass]="informative !== i+1 ? 'matBtn' : 'matBtnAfter'"
                    *ngFor="let Id of circleRatingArr; index as i"
                >
                    {{i+1}}
                </button>
            </div>
            <div class="tw-text-left tw-mt-[60px] tw-max-w-full tw-text-[16px] tw-font-semibold">
                {{ "CHATBOT_SURVEY_PAGE.YOUR_FEEDBACK" | translate }}
            </div>
            <form [formGroup]="feedbackForm">
                <textarea
                    class="tw-mt-[20px] tw-w-[100%] tw-h-36 tw-bg-gray-200 tw-font-[500] tw-overflow-auto tw-rounded-xl tw-pt-3.5 tw-pb-3.5 tw-px-6"
                    placeholder="{{
                        'CHATBOT_SURVEY_PAGE.PH_YOUR_FEEDBACK' | translate
                    }}"
                    formControlName="feedback"
                >
                </textarea>
            </form>

            <div
                class="tw-order-1 md:tw-order-3 tw-flex-[0_0_100%] md:tw-flex-[0_0_180px] tw-mb-[18px] md:tw-mb-0"
            >
                <button
                    class="tw-text-[18px] tw-leading-[20px] sm:tw-max-w-full tw-w-full tw-text-center tw-font-[600] tw-rounded-[32px] tw-text-white tw-py-[22px] tw-px-[15px] tw-mt-[20px]"
                    type="submit"
                    [ngClass]="
                        (
                            this.rating == 0 ||
                            this.overal_exp == 0 ||
                            this.ease_of_use == 0 ||
                            this.informative == 0
                        )
                        ? 'tw-bg-slate-300'
                        : 'tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300'
                    "
                    (click)="onSubmit()"
                >
                    {{ "COMMON.SUBMIT" | translate }}
                </button>
            </div>

            <div
                class="tw-mt-[40px] tw-order-2 md:tw-order-1 tw-flex-[0_0_calc(50%_-_5px)] md:tw-flex-[0_0_calc(100%_-_200px)]"
            >
                <button
                    (click)="onCancel()"
                    style="text-align: center;"
                    class="tw-text-caption-gray md:tw-max-w-full tw-w-full tw-text-justify tw-font-semibold"
                >
                    {{ "CANCEL" | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
<div
    *ngIf="submittedSuccessfully"
    (click)="closeMegaMenuCondition()"
    class="tw-hidden md:tw-hidden lg:tw-block"
>
    <div
        class="tw-flex tw-justify-center tw-gap-[6vw] md:tw-mt-[3rem] tw-px-[2rem] tw-py-[2rem]"
    >
        <div class="tw-mt-20">
            <div class="tw-flex tw-items-center tw-justify-center">
                <img
                    src="/assets/images/icons/Done.png"
                    alt="logo"
                    class="tw-h-auto tw-w-[64px] lg:tw-w-[64px]"
                />
            </div>
            <div class="tw-flex tw-items-center tw-justify-center">
                <div class="tw-text-[24px] tw-font-semibold tw-h-[32px] tw-mt-[40px]">
                    {{ "THANK_YOU" | translate }}
                </div>
            </div>
            <div class="tw-flex tw-items-center tw-justify-center">
                <div class="tw-text-[16px] tw-text-gray-400 tw-font-medium tw-h-[24px] tw-mt-[40px]">
                    {{ "REDIRECTION_MESSAGE" | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
<div
    *ngIf="submittedSuccessfully"
    (click)="closeMegaMenuCondition()"
    class="tw-block sm:tw-block lg:tw-hidden"
>
    <div
        class="tw-flex tw-justify-center tw-gap-[6vw] md:tw-mt-[3rem] tw-px-[2rem] tw-py-[2rem]"
    >
        <div class="tw-mt-20">
            <div class="tw-flex tw-items-center tw-justify-center">
                <img
                    src="/assets/images/icons/Done.png"
                    alt="logo"
                    class="tw-h-auto tw-w-[64px] lg:tw-w-[64px]"
                />
            </div>
            <div class="tw-flex tw-items-center tw-justify-center">
                <div class="tw-text-[24px] tw-font-semibold tw-h-[32px] tw-mt-[40px]">
                    {{ "THANK_YOU" | translate }}
                </div>
            </div>
            <div class="tw-flex tw-items-center tw-justify-center tw-mb-[40px]">
                <div class="tw-text-[16px] tw-text-gray-400 tw-font-medium tw-h-[24px] tw-mt-[40px] tw-text-center">
                    {{ "REDIRECTION_MESSAGE" | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer
    (click)="closeMegaMenuCondition()"
    [selectedLanguage]="languageSelected"
></app-footer>
